import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'noMidnight'
})
export class NoMidnightPipe implements PipeTransform {

    transform(value: string): string {
        return ( value === '00:00') ? '_____' : value;
    }

}
